// src/Store/cartStore.js
import { defineStore } from "pinia";
import Swal from "sweetalert2";

export const useCartStore = defineStore("cart", {
  state: () => ({
    cart: (() => {
      try {
        const cartData = localStorage.getItem("cart");
        return Array.isArray(JSON.parse(cartData)) ? JSON.parse(cartData) : [];
      } catch (error) {
        return []; // fallback if JSON is invalid
      }
    })(),
    totalPrice: 0,
  }),
  
  getters: {
    cartCount: (state) => state.cart.length,
    grandTotal: (state) => state.cart.reduce((sum, item) => sum + item.subTotal, 0),
    taxAmount: (state) => state.grandTotal * 0, // Assuming tax rate is 0% for now
    totalWithTax: (state) => state.grandTotal + state.taxAmount,
  },

  actions: {
    // Add item to cart
    addToCart(product, quantity, subTotal) {
      quantity = Number(quantity);
      subTotal = Number(subTotal);

      const existingItem = this.cart.find(item => item.id === product.id);
      if (existingItem) {
        Swal.fire({
          icon: 'info',
          title: 'Item already in cart',
          text: 'This item is already in your cart!',
        });
      } else {
        const newItem = { ...product, quantity, subTotal };
        this.cart.push(newItem);
        this.updateLocalStorage();
      }
    },

    // Update quantity of an item
    updateQuantity(id, newQuantity) {
      const item = this.cart.find(item => item.id === id);
      if (item) {
        item.quantity = newQuantity;
        // item.subTotal = item.current_price * item.price;
        item.subTotal = item.current_price * item.quantity;

        this.updateLocalStorage();
      }
    },

    // Remove item from cart
    removeItem(id) {
      this.cart = this.cart.filter(item => item.id !== id);
      this.updateLocalStorage();
    },

    // Clear all items from cart
    clearCart() {
      this.cart = [];
      this.updateLocalStorage();
    },

    // Helper function to update local storage
    updateLocalStorage() {
      localStorage.setItem("cart", JSON.stringify(this.cart));
    },

    // Reset cart on user logout or any other action
    resetCart() {
      this.clearCart();
      this.totalPrice = 0;
    }
  },
});
